import type { Provider } from '@angular/core';
import { ENVIRONMENT_INITIALIZER } from '@angular/core';

import { LoadJsonTranslationsService } from './load-json-translations.service';
import type { JsonModule, PartialFileName } from './interfaces';

export const provideTranslationLoader = (
  namespace: string,
  importTranslationFile: (path: PartialFileName) => Promise<JsonModule>
): Provider => ({
  provide: ENVIRONMENT_INITIALIZER,
  deps: [LoadJsonTranslationsService],
  multi: true,
  useFactory:
    (service: LoadJsonTranslationsService): (() => Promise<void>) =>
    () =>
      service.loadTranslationFiles(namespace, importTranslationFile),
});
